import { orderBy } from "lodash-es";
import {
  IContact,
  IFile,
  IImageItem,
  IInfoBlockItem,
  IInfoBlockItemType,
  IPlace,
} from "shared/types";

export const getSortedInfoBlockItems = (
  items: IInfoBlockItemType[],
  type: IInfoBlockItem
) => {
  switch (type) {
    case IInfoBlockItem.contact:
      const contactSorter = (contact: IContact) =>
        contact.lastname && contact.lastname.toLowerCase();
      return orderBy(items, [contactSorter]) as IContact[];
    case IInfoBlockItem.place:
      const placeSorter = (place: IPlace) => place.title.toLowerCase();
      return orderBy(items, [placeSorter]) as IPlace[];
    case IInfoBlockItem.file:
      const fileSorter = (file: IFile) => file.title.toLowerCase();
      return orderBy(items, [fileSorter]) as IFile[];
    case IInfoBlockItem.image:
      return items as IImageItem[];
    default:
      return items;
  }
};
